import React, { Component } from "react";
import __ from "lodash";
import { connect } from "react-redux";
import { cekCookies } from "../../../../actions";
import LoaderModal from "../../../../components/modal/LoaderModal";
import { CONFIG } from "../../../../config";
import accountManagement from "../../../../apis/accountManagement";
import { Row, Col, Alert, Table } from "react-bootstrap";
import "../../../../components/dashboard/content/report/tryout/circlebar.css";
// import "./reportsbmptn.css";
import { TableHead, TableRow, TableCell, TableBody } from "@material-ui/core";
import { Gap, Line } from "../../../../components/Global";

class RekapSekolah extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isFetching: false,
            showIndikator: false,
            jumMapel: null,
            dataMapel: null,
            detail: {},
            siswa: {},
            skorNonCampuran: {},
            skorSaintek: {},
            skorSoshum: {},
            dataAll: [],
        };
    }

    async componentDidMount() {
        document.title = "Report SBMPTN";
        this.setState({ isFetching: true });
        await this.props.cekCookies();
        if (!__.isEmpty(this.props.account)) {
            this.fetchData();
        }
    }

    fetchData = async () => {
        const param = this.props.match.params;
        let qString = {
            idSekolah: this.props.account.idSekolah,
            idKelas: param.idKelas,
            idJadwal: param.idJadwal,
            kelompok: param.kelompok,
        };

        const response = await accountManagement
            .get(CONFIG.REPORT_CBT_SBMPTN, {
                params: qString,
            })
            .catch(function (error) {
                console.log(error);
            });
        if (response) {
            if (response.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
                this.setState({
                    detail: response.data.data.detail,
                    siswa: response.data.data.siswa,
                    dataMapel: response.data.data.mapel,
                    skorNonCampuran: response.data.data.skorNonCampuran,
                    skorSaintek: response.data.data.skorSaintek,
                    skorSoshum: response.data.data.skorSoshum,
                    jumMapel: response.data.data.jumMapel,
                    dataAll: response.data.data.resultAll,
                });
            }
            this.setState({ isFetching: false });
        }
        this.setState({ isFetching: false });
    };

    renderTableParent() {
        let { dataMapel, siswa, dataAll, skorNonCampuran, skorSaintek, skorSoshum, jumMapel, detail } = this.state;
        if (!__.isEmpty(dataAll)) {
            return (
                <Table className="table">
                    <TableHead>
                        <TableRow style={{ backgroundColor: "#BEF264" }}>
                            <TableCell className="table-font-kecil-tengah" style={{ width: 25 }}>
                                No.
                            </TableCell>
                            <TableCell className="table-font-kecil">Nama Siswa</TableCell>
                            {dataMapel.map((mapel, mp) => (
                                <TableCell key={mp} className="table-font-kecil-tengah">
                                    {mapel.namaMapel}
                                </TableCell>
                            ))}
                            {detail.kelompok != "CAMPURAN" ? (
                                <>
                                    {/* <TableCell className="table-font-kecil-tengah">Total Nilai</TableCell> */}
                                    <TableCell className="table-font-kecil-tengah">Rata Nilai</TableCell>
                                </>
                            ) : (
                                <>
                                    {/* <TableCell className="table-font-kecil-tengah">Total Nilai</TableCell> */}
                                    <TableCell className="table-font-kecil-tengah">Rata Nilai</TableCell>
                                    {/* <TableCell className="table-font-kecil-tengah">Rata Saintek</TableCell>
                                    <TableCell className="table-font-kecil-tengah">Rata Soshum</TableCell> */}
                                </>
                            )}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {siswa.map((sis, sw) => (
                            <TableRow key={sw}>
                                <TableCell className="table-font-kecil-tengah">{sw + 1}.</TableCell>
                                <TableCell className="table-font-kecil">{sis.namaSiswa}</TableCell>
                                {dataMapel.map((mapel, mp) => dataAll.map((data, j) => mapel.idMapel === data.idMataPelajaran && data.idSiswa === sis.idSiswa && <TableCell className="table-font-kecil-tengah">{data.skor}</TableCell>))}

                                {detail.kelompok != "CAMPURAN" ? (
                                    skorNonCampuran.map(
                                        (listSkor, sk) =>
                                            listSkor.idSiswa === sis.idSiswa && (
                                                <>
                                                    {/* <TableCell className="table-font-kecil-tengah">{listSkor.totSkor}</TableCell> */}
                                                    <TableCell className="table-font-kecil-tengah">{(listSkor.totSkor / jumMapel).toFixed(2)}</TableCell>
                                                </>
                                            )
                                    )
                                ) : (
                                    <>
                                        {skorNonCampuran.map(
                                            (listSkor, sk) =>
                                                listSkor.idSiswa === sis.idSiswa && (
                                                    <>
                                                        {/* <TableCell className="table-font-kecil-tengah">{listSkor.totSkor}</TableCell> */}
                                                        <TableCell className="table-font-kecil-tengah">{(listSkor.totSkor / jumMapel).toFixed(2)}</TableCell>
                                                    </>
                                                )
                                        )}
                                    </>
                                )}
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            );
        } else {
            return (
                <Row>
                    <Col>
                        <b>Data tidak tersedia</b>
                    </Col>
                </Row>
            );
        }
    }

    render() {
        const { detail } = this.state;
        require("./RekapSekolah.css");
        return (
            <div>
                <LoaderModal isFetching={this.state.isFetching} />
                <div className="report-page">
                    <div className="cardLine">
                        <div className="pnl-header">
                            <div className="card-page">
                                <span style={{
                                    fontSize: '26px',
                                    color: '#FFF',
                                    fontWeight: 500,
                                    fontFamily: 'lucida grande'
                                }}>01</span>
                            </div>
                            <div className="pnl-date">
                                https://eduprime.co.id/
                            </div>
                        </div>
                        <div className="header-first-page-agcu" style={{ padding: '0 3%' }}>
                            <div className="text-header">
                                <div className="title-header" style={{ color: '#015E56' }}>UNIVERSITY SELECTION SYSTEM</div>
                                <div className="label-sub-tit">
                                    <sapn className="sub-title-header" style={{ color: '#FFF' }}>Seleksi Nasional Berdasarkan Tes (SNBT)</sapn>
                                </div>
                            </div>
                            <div className="image-header">
                                <div className="logo-eduprime">
                                    <img src="https://eduprime.co.id/static/images/LogoEduprimePutih.png" width={"100%"} alt="" />
                                </div>
                                <div className="logo-cbt"><img src="/assets/image/uss.png" style={{ width: "100%" }} alt="" /></div>
                            </div>
                        </div>
                        <Gap height={40} />
                        <div className="pnl-profile">
                            <div className="card-profile">
                                <div>
                                    <img src="/assets/image/icon-sekolah.svg" width="60px" alt="" />
                                </div>
                                <div>
                                    <spann className="label-profile-name">Nama Sekolah</spann>
                                    <p className="label-profile-value">{detail.namaSekolah}</p>
                                </div>
                            </div>
                            <div className="card-profile">
                                <div>
                                    <img src="/assets/image/icon-kelas.svg" width="60px" alt="" />
                                </div>
                                <div>
                                    <spann className="label-profile-name">Kelas</spann>
                                    <p className="label-profile-value">{detail.namaKelas}</p>
                                </div>
                            </div>
                        </div>
                        <Row>
                            <Col>{this.renderTableParent()}</Col>
                        </Row>
                    </div>
                    <Gap height={40} />
                    <div id="btn_print">
                        <div className="fixed_button">
                            <button className="btn btn-outline-primary btn133w pull-right" style={{ marginRight: "1em" }} onClick={() => window.print()}>
                                Print
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
const mapStateToProps = (state) => {
    return {
        account: state.account,
    };
};

export default connect(mapStateToProps, { cekCookies })(RekapSekolah);
